export const useAbTestStore = defineStore('abtest', {
  state: () => ({
    tests: {},
    xid: null,
  }),

  actions: {
    INIT({ headers, url }) {
      // Store test from headers, set by Vercel Edge Middleware
      this.tests = Object.entries(headers || {}).reduce((acc, [key, value]) => {
        if (key?.match(/x-abtest-/)) {
          const matches = value.match(/test-name=(.+), bucket=(.+)/)
          if (!matches?.length) return acc
          acc[matches[1]] = {
            value: matches[2],
            header: key,
          }
        }
        return acc
      }, {})

      // Store XID from header set by edge middleware
      if (headers?.['x-xid']) {
        this.xid = headers['x-xid']
      }

      // Override tests with query parameters
      for (const key of url.searchParams.keys()) {
        const value = url.searchParams.get(key)
        if (key?.match(/^ab[_-]/)) {
          const testKey = key.replace(/^ab[_-]/, '')
          this.tests[testKey] = {
            value,
            header: null,
          }
        } else if (key?.match(/^hab/)) {
          // hab = hashed ab test
          // Use these to override tests without obviously exposing the test name
          // The hash has the format key:variantId and is then URL safe base64 encoded
          try {
            const encoded = key.replace(/^hab/, '')
            const decoded = Buffer.from(encoded, 'base64').toString('utf-8')
            const [testKey, value] = decoded.split(':')

            this.tests[testKey] = {
              value,
              header: null,
            }
          } catch (e) {
            // Do nothing
            console.log(e)
          }
        }
      }
    },
  },
})
